import { WorkflowFromTemplateFormSchema } from '@/features/workflow/models/workflow';
import { useForm } from '@/hooks';
import { zodResolver } from '@hookform/resolvers/zod';
import type { FC, PropsWithChildren } from 'react';
import { FormProvider } from 'react-hook-form';
import type { z } from 'zod';

type FormValues = z.infer<typeof WorkflowFromTemplateFormSchema>;

export const WorkflowCreateFromTemplateFormProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const formMethods = useForm<FormValues>({
    defaultValues: {
      assigneeIds: [],
      sharedOrganizationRecursiveIds: [],
      tagIds: [],
    },
    resolver: zodResolver(WorkflowFromTemplateFormSchema),
  });

  return <FormProvider {...formMethods}>{children}</FormProvider>;
};
